export default __webpack_public_path__ + "9c29f96576f731c5d47a2c1d13e17a67.png";